import type { AmbientScribe, DeepgramInput } from "services/types/ambient-scribe.type";
import type { MedicalScribe } from "../medical-scribes.type";

export function formatSecondsToHHMMSS(
  seconds: number | null | undefined
): string {
  const value = Number(seconds);
  const hours = Math.floor(value / 3600);
  const mins = Math.floor((value % 3600) / 60);
  const secs = value % 60;
  return [
    hours.toString().padStart(2, "0"),
    mins.toString().padStart(2, "0"),
    secs.toString().padStart(2, "0"),
  ].join(":");
}

export const getMedicalScribeText = (
  scribe: MedicalScribe | AmbientScribe | undefined | null
) => {
  if (!scribe) return "";

  // `alternatives: []` is a real payload (a Deepgram run that produced nothing),
  // and this is called unconditionally while rendering the Transcript tab — a
  // missing `?.` here threw during render and took the whole dialog down.
  return (
    scribe?.transcription?.channels?.at(0)?.alternatives?.at(0)?.transcript || ""
  );
};

/** Plain text or Deepgram JSON from a recording session transcript field. */
export const getSessionTranscriptionText = (
  transcription: string | DeepgramInput | null | undefined
): string => {
  if (!transcription) return "";
  if (typeof transcription === "string") return transcription.trim();
  return (
    transcription.channels?.at(0)?.alternatives?.at(0)?.transcript?.trim() ??
    ""
  );
};

/** MM:SS with zero-padded minutes (e.g. 03:09, 00:08). Fractional seconds are floored. */
export function formatAudioDurationMmSs(seconds: number): string {
  const totalSec = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
